import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';

import subscriptionService from '../../../services/subscription/SubscriptionService';
import * as snackbarsActions from '../../../actions/snackbars';
import {setNewSubscription} from '../../../actions/subscription';
import {captureError} from '../../../utils/log';
import PlanSelection from '../../../components/PlanSelection';

import PlanSelectionQuestion from './PlanSelectionQuestion';

import {getSuggestedPlans, getCurrentPlan} from './utils';

function OrganisationRegisterPlanContainer() {
  const organisation = useSelector(state => state.organisation);
  const history = useHistory();
  const [currentPlan, setCurrentPlan] = useState();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  function endRegistrationProcess(hasPerformedAPlanSelection, planIsDepositor) {
    if (hasPerformedAPlanSelection) {
      history.replace(`/dashboard${planIsDepositor ? '?organisationRegistrationSuccessful=true' : ''}`);
    } else {
      history.replace('/global-dashboard');
    }
  }

  async function fetchPlans(selectedOrganisation, answers) {
    try {
      setLoading(true);

      const suggestedPlans = await getSuggestedPlans(selectedOrganisation.organisationId, answers);

      setPlans(suggestedPlans);
    } catch (error) {
      captureError('subscriptionService.getSuggestedPlans', error);
      dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
    } finally {
      setLoading(false);
    }
  }

  async function init(selectedOrganisation) {
    try {
      setLoading(true);

      const selectedCurrentPlan = await getCurrentPlan(selectedOrganisation.organisationId);

      if (
        selectedCurrentPlan?.upgradable !== undefined &&
        !selectedCurrentPlan.upgradable
      ) {
        // Can't upgrade subscription's plan, redirect user
        endRegistrationProcess(false);
        return;
      }

      setCurrentPlan(selectedCurrentPlan);
    } catch (error) {
      captureError('subscriptionService.findSubscriptionByOrganisation', error);
      dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (!organisation) {
      // Can't select a plan if you have no organisation
      endRegistrationProcess(false);
    } else {
      init(organisation);
    }
  }, [organisation]);

  const handlePlanSelection = async plan => {
    setLoading(true);

    try {
      if (currentPlan?.upgradable) {
        // Treat as upgrade
        await subscriptionService.upgradeToPlan(organisation.organisationId, plan);
      } else {
        // Treat as first plan selection
        await subscriptionService.subscribeToPlan(organisation.organisationId, plan);

        // set subscription
        dispatch(setNewSubscription(organisation.organisationId));
      }

      endRegistrationProcess(true, plan.depositor);
    } catch (error) {
      captureError(currentPlan?.upgradable ? 'subscriptionService.upgradeToPlan' : 'subscriptionService.subscribeToPlan', error);
      dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <div className="loading-overlay"/>}
      <div className="col-12 inline-container justify-content-center information-primary">
        <h1><strong><Translate value="subscriptions.title"/></strong></h1>
      </div>
      <PlanSelectionQuestion
        submit={answers => fetchPlans(organisation, answers)}
      />
      <PlanSelection
        loading={loading}
        plans={plans}
        onPlanSelection={handlePlanSelection}
        currentPlan={currentPlan}
      />
    </div>
  );
}

export default OrganisationRegisterPlanContainer;
